import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { ChargingIntroductionModule } from '../introduction/introduction.module';
import { ChargingCardInputModule } from './charging-card-input/charging-card-input.module';
import { ChargingCardOutboundFormModule } from './outbound/form/form.module';
import { ChargingCardOutboundInfoModule } from './outbound/info/info.module';

@NgModule({
  imports: [
    CommonModule,
    ChargingIntroductionModule,
    ChargingCardInputModule,
    ChargingCardOutboundInfoModule,
    ChargingCardOutboundFormModule,
  ],
})
export class ChargingCardModule {}
_('modules.evsb.chargingCard.input.list.1.item');
_('modules.evsb.chargingCard.input.list.2.item');
_('modules.evsb.chargingCard.input.list.3.item');
